/**
 * Vue Router 路由配置
 * - createWebHistory：URL 用真实路径（/packs、/lessons/xxx/play）
 * - 生产构建后由 FastAPI 兜底回 dist/index.html（SPA fallback）
 */
import { createRouter, createWebHistory } from 'vue-router'
import HomePage from '@/views/HomePage.vue'
import PacksPage from '@/views/PacksPage.vue'
import PackEditPage from '@/views/PackEditPage.vue'
import PlayerPage from '@/views/PlayerPage.vue'
import SettingsPage from '@/views/SettingsPage.vue'

const routes = [
  { path: '/',                    name: 'Home',    component: HomePage },
  { path: '/packs',               name: 'Packs',   component: PacksPage },
  { path: '/packs/:id/edit',      name: 'PackEdit', component: PackEditPage, props: true },
  { path: '/lessons/:id/play',    name: 'Player',  component: PlayerPage, props: true },
  { path: '/settings',            name: 'Settings', component: SettingsPage },
  // 兜底：未匹配的路径回首页
  { path: '/:pathMatch(.*)*',     redirect: '/' },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() { return { top: 0 } },
})

export default router
